import { defineStore } from 'pinia'

export const useTokenStore = defineStore({
  id: 'token-store',
  state: () => {
    // Initialize token from sessionStorage if available
    let initialToken = "";
    if (typeof window !== 'undefined') {
      try {
        const loginStr = sessionStorage.getItem("myquote-login");
        if (loginStr) {
          const login = JSON.parse(loginStr);
          if (login && login.accessToken) {
            initialToken = login.accessToken;
          }
        }
      } catch (error) {
        console.error('[TokenStore] Error initializing from sessionStorage:', error);
      }
    }
    return { currentValue: initialToken }
  },
  actions: {
    updateToken(value: string) {
      this.currentValue = value;
    },
  },
  getters: {
    token: state => state.currentValue
  }
})
